<template>
  <div class="main_right">
    <div class="Box">
      <div class="testpage" style="height:100%;">
        <p>
          <span>单词前测</span>
        </p>
        <div class="btnWrap">
          <div class="preBtn" @click="openLink('https://my.vocabularysize.com')">
            <p class="cn">单词前测1</p>
            <p class="en">test your word knowledge</p>
          </div>
          <div class="preBtn" @click="openLink('https://www.efset.org')">
            <p class="cn">单词前测2</p>
            <p class="en">test your English now</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    openLink(url) {
      window.open(url, '_blank')
    }
  }
}
</script>
<style lang="scss" scoped>
.main_right {
  width: calc(100% - 10.5vw);
  height: 100%;
  float: left;
  box-sizing: border-box;
  padding: 0 2%;
  position: relative;

  .Box {
    width: 100%;
    height: 100%;
    box-shadow: 0px 0px 16px 0px rgba(89, 144, 255, 0.3);
    border-radius: 10px;
    padding: 2%;
    box-sizing: border-box;
    position: relative;
  }

  .testpage {
    width: 100%;
    position: relative;

    p:nth-child(1) {
      width: 100%;
      height: 2.5vw;
      text-align: center;
      position: relative;
      color: #333;
      font-size: 1.5vw;
      line-height: 2.5vw;
    }
  }

  .btnWrap {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 3vw;
    margin-top: 4vw;

    .preBtn {
      width: 18vw;
      height: 8vw;
      background: #f1f8ff;
      border-radius: 10px;
      box-shadow: 0px 0px 7px 1px rgba(89, 144, 255, 0.3);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      transition: all 0.3s ease;

      .cn {
        font-size: 1.6vw;
        color: #5990ff;
        font-weight: 600;
        margin-bottom: 0.8vw;
      }

      .en {
        font-size: 1vw;
        color: #333;
      }
    }

    .preBtn:hover {
      background: #5990ff;
      box-shadow: 0px 0px 12px 2px rgba(89, 144, 255, 0.5);

      .cn,
      .en {
        color: #fff;
      }
    }
  }
}

/* ========== 手机端适配样式 ========== */
@media screen and (max-width: 768px) {
  .main_right {
    width: calc(100% - 80px);
    padding: 0 10px;

    .Box {
      padding: 12px 10px;
    }

    .testpage {
      p:nth-child(1) {
        height: 36px;
        line-height: 36px;
        font-size: 14px;
      }
    }

    .btnWrap {
      flex-direction: column;
      gap: 20px;
      margin-top: 40px;

      .preBtn {
        width: 100%;
        max-width: 320px;
        height: auto;
        padding: 20px 0;

        .cn {
          font-size: 18px;
          margin-bottom: 8px;
        }

        .en {
          font-size: 12px;
        }
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .main_right {
    width: calc(100% - 65px);
    padding: 0 8px;

    .testpage p:nth-child(1) {
      height: 32px;
      line-height: 32px;
      font-size: 13px;
    }

    .btnWrap .preBtn {
      padding: 16px 0;

      .cn {
        font-size: 16px;
      }

      .en {
        font-size: 11px;
      }
    }
  }
}
</style>
